import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

import { DataCollection } from '../../models/site-content/data-collection.model';
import { CopySiteService } from '../../services/copy-site.service';
import { AsyncJobService } from '../../services/async-job.service';
import { AsyncJob } from '../../models/async-job.model';
import { AsyncJobDialogBase, JOB_COMPLETED_MESSAGE } from '../async-job-base/async-job-base.dialog';

@Component({
    selector: 'app-copy-site',
    templateUrl: './copy-site.dialog.html',
    styleUrls: ['./copy-site.dialog.scss'],
    standalone: false
})
export class CopySiteDialog extends AsyncJobDialogBase implements OnInit {
    // Properties.
    private siteCopyName: string = null;
    private siteCopyId: number = -1;

    public constructor(public dialogRef: MatDialogRef<CopySiteDialog>,
        @Inject(MAT_DIALOG_DATA) public siteToCopy: DataCollection,
        private copySiteService: CopySiteService,
        private injectedAsyncJobService: AsyncJobService)
    {
        super(injectedAsyncJobService);

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'CopySiteDialog';
    }

    // Life cycle methods.
    public ngOnInit(): void {
        this.siteCopyName = `${this.siteToCopy.name} Copy`;

        return;
    }

    // Accessor methods.
    public get SiteCopyName(): string {
        return (this.siteCopyName);
    }
    public set SiteCopyName(siteCopyNameParam: string) {
        this.siteCopyName = siteCopyNameParam;

        return;
    }

    /*
    public get CompletedSiteCopyName(): string {
        return (this.jobCompleted ? this.siteCopyName : null);
    }
    */
    public get CompletedSiteCopyId(): number {
        return (this.jobCompleted ? this.siteCopyId : null);
    }

    public get DismissButtonTitle(): string {
        //return (this.jobCompleted && (!this.jobErrorOccurred) ? 'Dismiss, Load Copied Site' : 'Dismiss');
        return ('Dismiss');
    }

    public get CopyStatus(): string {
        let status: string = null;

        if ((!this.jobInProgress) && (this.asyncJobInfo == null)) {
            // We haven't started a copy job.
            status = 'Not started';
        } else if (this.jobInProgress) {
            // A copy job is in progress.
            status = 'Copy in progress';
        } else if (!this.jobErrorOccurred) {
            // A copy completed without error.
            status = JOB_COMPLETED_MESSAGE;//'Completed';
        } else {
            // A copy error occurred.
            status = 'A copy error occurred';
        }

        return (status);
    }

    // Handle dialogue action(s).
    public startSiteCopy(): void {
        // Initiate the copy.
        this.copySiteService.copySite(this.siteToCopy.id, this.siteCopyName).then(asyncJob => {
            // Save the returned job key.
            this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction);
        });

        return;
    }

    // Implement private helper methods.
    private jobCompletedArrowFunction = (asyncJob: AsyncJob): void => {
        this.siteCopyId = this.parseCreatedSiteId(asyncJob);

        return;
    }
}
